























































































































































































import { Component, Vue } from "vue-property-decorator";
import FileDrop from "@/components/common/FileDrop.vue";
import FileItem from "@/components/common/FileItem.vue";
import DropZone from "@/components/common/DropZone.vue";
import { API, Storage } from "aws-amplify";

import { Urls } from "@/Urls";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";

const decisionsModule = getModule(Decisions)
@Component({
    components: {DropZone, FileItem, FileDrop},
})
export default class DecisionFileImport extends Vue {

    private step = 1;
    private file: any = null;
    private name = '';
    private description = '';
    private uploadError = null;
    private uploading = false;
    private uploaded = false;
    private uploadProgressPercent: number | null = null
    private objectKey: string | null = null;

    private API_NAME = "Viewpoint360API";

    private async fileSelected(files: any) {
        this.file = files[0];
        try {
            this.uploadError = null;
            this.objectKey = await this.uploadFile(this.file);
            this.step++;
        } catch (e) {
            this.uploadError = e
        }

    }

    private async uploadFile(file: any) {
        const key: string = `ingest/csv/${file.name}`;
        this.uploading = true;
        let uploadResponse: any = await Storage.put(key, file, {
            progressCallback: (progress: any) => {
                this.uploadProgressPercent = progress.loaded / progress.total
            }
        })
        this.uploading = false;
        this.uploaded = true;
        return uploadResponse.key;
    }

    private async submit() {
        this.step = 3;
        const path = '/ingest/decision';
        const myInit = {
            body: {
                bucket: process.env.VUE_APP_STORAGE_S3_BUCKET,
                key: `public/${this.objectKey}`,
                name: this.name,
                description: this.description,
                // dataSourceId: '',
            }
        };

        try {
            let createdDecision = await API.post(this.API_NAME, path, myInit)
            decisionsModule.addDecision(createdDecision)
            await decisionsModule.selectDecision(createdDecision.decisionId);
            this.$router.push(Urls.TEMPLATE_BUILDER)
        } catch (err) {
            this.uploadError = err
        }
    }

}
